<div class="prio-message-container"
    #container>
    <ul class="prio-messages"
        #list
        [class.animate]="scrolling()"
        [class.single-item]="single()"
        [class.no-animation]="still()">
        @for (message of messages(); track message.id) {
        <li>
            <span class="prio-subject">{{ message.subject }}</span>@if (message.text) {<span
                class="prio-body">: {{ message.text }}</span>}
        </li>
        }
    </ul>
    @if (scrolling()) {
    <ul class="prio-messages animate"
        aria-hidden="true">
        @for (message of messages(); track message.id) {
        <li>
            <span class="prio-subject">{{ message.subject }}</span>@if (message.text) {<span
                class="prio-body">: {{ message.text }}</span>}
        </li>
        }
    </ul>
    }
</div>
